// extracted by mini-css-extract-plugin
export default {"input":"AD8f6b","msgvalid":"lExgZk"};